<template>


</template>

<script>
export default {
    name: "SocialMedia"
}
</script>

<style scoped>

</style>
